export type CommentEmoji = {
  emoji: string;
  keywords: string;
  name: string;
};

export const COMMENT_EMOJIS: CommentEmoji[] = [
  { emoji: '😀', name: 'Grinning face', keywords: 'happy smile face' },
  { emoji: '😃', name: 'Smiling face', keywords: 'happy smile face' },
  { emoji: '😄', name: 'Big smile', keywords: 'happy grin face' },
  { emoji: '😁', name: 'Beaming face', keywords: 'happy grin face' },
  { emoji: '😆', name: 'Laughing face', keywords: 'laugh lol happy' },
  { emoji: '😂', name: 'Tears of joy', keywords: 'laugh lol funny cry' },
  { emoji: '🤣', name: 'Rolling laughing', keywords: 'laugh lol funny' },
  { emoji: '😊', name: 'Warm smile', keywords: 'happy blush smile' },
  { emoji: '🙂', name: 'Slight smile', keywords: 'smile happy' },
  { emoji: '🙃', name: 'Upside down face', keywords: 'silly smile' },
  { emoji: '😉', name: 'Winking face', keywords: 'wink smile' },
  { emoji: '😍', name: 'Heart eyes', keywords: 'love heart eyes' },
  { emoji: '🥰', name: 'Smiling hearts', keywords: 'love heart happy' },
  { emoji: '😘', name: 'Kiss face', keywords: 'kiss love' },
  { emoji: '😗', name: 'Kissing face', keywords: 'kiss love' },
  { emoji: '😙', name: 'Kissing smile', keywords: 'kiss happy' },
  { emoji: '😚', name: 'Kissing closed eyes', keywords: 'kiss love' },
  { emoji: '😋', name: 'Yum face', keywords: 'food tasty tongue' },
  { emoji: '😛', name: 'Tongue face', keywords: 'silly tongue' },
  { emoji: '😜', name: 'Winking tongue', keywords: 'silly wink tongue' },
  { emoji: '🤪', name: 'Zany face', keywords: 'silly crazy' },
  { emoji: '😝', name: 'Squinting tongue', keywords: 'silly tongue' },
  { emoji: '🤑', name: 'Money face', keywords: 'money cash' },
  { emoji: '🤗', name: 'Hugging face', keywords: 'hug happy' },
  { emoji: '🤭', name: 'Hand over mouth', keywords: 'oops laugh' },
  { emoji: '🫢', name: 'Shocked hand mouth', keywords: 'oops shock' },
  { emoji: '🤫', name: 'Shushing face', keywords: 'quiet secret' },
  { emoji: '🤔', name: 'Thinking face', keywords: 'think question' },
  { emoji: '🫡', name: 'Saluting face', keywords: 'respect salute' },
  { emoji: '🤐', name: 'Zipper mouth', keywords: 'quiet secret' },
  { emoji: '🤨', name: 'Raised eyebrow', keywords: 'skeptical question' },
  { emoji: '😐', name: 'Neutral face', keywords: 'meh neutral' },
  { emoji: '😑', name: 'Expressionless face', keywords: 'meh blank' },
  { emoji: '😶', name: 'No mouth face', keywords: 'quiet blank' },
  { emoji: '😏', name: 'Smirk', keywords: 'smirk face' },
  { emoji: '😒', name: 'Unamused face', keywords: 'meh annoyed' },
  { emoji: '🙄', name: 'Rolling eyes', keywords: 'eyeroll annoyed' },
  { emoji: '😬', name: 'Grimacing face', keywords: 'awkward nervous' },
  { emoji: '😮‍💨', name: 'Exhaling face', keywords: 'relief sigh' },
  { emoji: '🤥', name: 'Lying face', keywords: 'lie nose' },
  { emoji: '😌', name: 'Relieved face', keywords: 'calm relief' },
  { emoji: '😔', name: 'Sad pensive face', keywords: 'sad down' },
  { emoji: '😪', name: 'Sleepy face', keywords: 'sleep tired' },
  { emoji: '🤤', name: 'Drooling face', keywords: 'drool hungry' },
  { emoji: '😴', name: 'Sleeping face', keywords: 'sleep tired' },
  { emoji: '😷', name: 'Mask face', keywords: 'sick mask' },
  { emoji: '🤒', name: 'Thermometer face', keywords: 'sick fever' },
  { emoji: '🤕', name: 'Bandage face', keywords: 'hurt sick' },
  { emoji: '🤢', name: 'Nauseated face', keywords: 'sick gross' },
  { emoji: '🤮', name: 'Vomiting face', keywords: 'sick gross puke' },
  { emoji: '🤧', name: 'Sneezing face', keywords: 'sick sneeze' },
  { emoji: '🥵', name: 'Hot face', keywords: 'hot sweaty' },
  { emoji: '🥶', name: 'Cold face', keywords: 'cold frozen' },
  { emoji: '🥴', name: 'Woozy face', keywords: 'dizzy drunk' },
  { emoji: '😵', name: 'Dizzy face', keywords: 'dizzy shock' },
  { emoji: '🤯', name: 'Exploding head', keywords: 'mind blown wow' },
  { emoji: '🤠', name: 'Cowboy face', keywords: 'cowboy hat' },
  { emoji: '🥳', name: 'Party face', keywords: 'party celebrate birthday' },
  { emoji: '🥸', name: 'Disguised face', keywords: 'glasses disguise' },
  { emoji: '😎', name: 'Sunglasses face', keywords: 'cool shades' },
  { emoji: '🤓', name: 'Nerd face', keywords: 'nerd glasses' },
  { emoji: '🧐', name: 'Monocle face', keywords: 'fancy inspect' },
  { emoji: '😕', name: 'Confused face', keywords: 'confused question' },
  { emoji: '🫤', name: 'Diagonal mouth face', keywords: 'meh unsure' },
  { emoji: '😟', name: 'Worried face', keywords: 'worry sad' },
  { emoji: '🙁', name: 'Slight frown', keywords: 'sad frown' },
  { emoji: '☹️', name: 'Frowning face', keywords: 'sad frown' },
  { emoji: '😮', name: 'Open mouth face', keywords: 'wow surprise' },
  { emoji: '😯', name: 'Hushed face', keywords: 'surprise quiet' },
  { emoji: '😲', name: 'Astonished face', keywords: 'wow shocked' },
  { emoji: '😳', name: 'Flushed face', keywords: 'blush surprised' },
  { emoji: '🥺', name: 'Pleading face', keywords: 'please sad' },
  { emoji: '🥹', name: 'Holding back tears', keywords: 'cry happy touched' },
  { emoji: '😦', name: 'Frowning open mouth', keywords: 'sad shocked' },
  { emoji: '😧', name: 'Anguished face', keywords: 'sad worry' },
  { emoji: '😨', name: 'Fearful face', keywords: 'scared afraid' },
  { emoji: '😰', name: 'Anxious sweat', keywords: 'nervous scared sweat' },
  { emoji: '😥', name: 'Sad relieved face', keywords: 'sad relief' },
  { emoji: '😢', name: 'Crying face', keywords: 'sad cry tears' },
  { emoji: '😭', name: 'Loud crying face', keywords: 'sad cry tears' },
  { emoji: '😱', name: 'Screaming face', keywords: 'scared shocked' },
  { emoji: '😖', name: 'Confounded face', keywords: 'frustrated' },
  { emoji: '😣', name: 'Persevering face', keywords: 'struggle' },
  { emoji: '😞', name: 'Disappointed face', keywords: 'sad disappointed' },
  { emoji: '😓', name: 'Downcast sweat', keywords: 'sad sweat' },
  { emoji: '😩', name: 'Weary face', keywords: 'tired sad' },
  { emoji: '😫', name: 'Tired face', keywords: 'tired exhausted' },
  { emoji: '🥱', name: 'Yawning face', keywords: 'sleep tired bored' },
  { emoji: '😤', name: 'Triumph face', keywords: 'proud angry steam' },
  { emoji: '😡', name: 'Pouting face', keywords: 'angry mad' },
  { emoji: '😠', name: 'Angry face', keywords: 'mad angry' },
  { emoji: '🤬', name: 'Cursing face', keywords: 'angry swear' },
  { emoji: '😈', name: 'Smiling devil', keywords: 'devil naughty' },
  { emoji: '👿', name: 'Angry devil', keywords: 'devil angry' },
  { emoji: '💀', name: 'Skull', keywords: 'dead skull' },
  { emoji: '☠️', name: 'Skull crossbones', keywords: 'danger dead' },
  { emoji: '💩', name: 'Poop', keywords: 'poop funny' },
  { emoji: '🤡', name: 'Clown face', keywords: 'clown funny' },
  { emoji: '👻', name: 'Ghost', keywords: 'ghost spooky' },
  { emoji: '👽', name: 'Alien', keywords: 'alien space' },
  { emoji: '🤖', name: 'Robot', keywords: 'robot bot' },
  { emoji: '😺', name: 'Grinning cat', keywords: 'cat happy' },
  { emoji: '😸', name: 'Smiling cat', keywords: 'cat happy' },
  { emoji: '😹', name: 'Laughing cat', keywords: 'cat laugh' },
  { emoji: '😻', name: 'Heart eyes cat', keywords: 'cat love' },
  { emoji: '😼', name: 'Smirking cat', keywords: 'cat smirk' },
  { emoji: '🙀', name: 'Weary cat', keywords: 'cat shocked' },
  { emoji: '😿', name: 'Crying cat', keywords: 'cat sad cry' },
  { emoji: '😾', name: 'Pouting cat', keywords: 'cat angry' },
  { emoji: '🙈', name: 'See no evil', keywords: 'monkey hide' },
  { emoji: '🙉', name: 'Hear no evil', keywords: 'monkey hear' },
  { emoji: '🙊', name: 'Speak no evil', keywords: 'monkey speak' },
  { emoji: '💋', name: 'Kiss mark', keywords: 'kiss lips' },
  { emoji: '💌', name: 'Love letter', keywords: 'love letter heart' },
  { emoji: '💘', name: 'Heart arrow', keywords: 'love heart cupid' },
  { emoji: '💝', name: 'Heart gift', keywords: 'love heart gift' },
  { emoji: '💖', name: 'Sparkling heart', keywords: 'love heart sparkle' },
  { emoji: '💗', name: 'Growing heart', keywords: 'love heart' },
  { emoji: '💓', name: 'Beating heart', keywords: 'love heart' },
  { emoji: '💞', name: 'Revolving hearts', keywords: 'love hearts' },
  { emoji: '💕', name: 'Two hearts', keywords: 'love hearts' },
  { emoji: '💟', name: 'Heart decoration', keywords: 'love heart' },
  { emoji: '❣️', name: 'Heart exclamation', keywords: 'love heart' },
  { emoji: '💔', name: 'Broken heart', keywords: 'sad heart love' },
  { emoji: '❤️', name: 'Red heart', keywords: 'love heart' },
  { emoji: '🩷', name: 'Pink heart', keywords: 'love heart' },
  { emoji: '🧡', name: 'Orange heart', keywords: 'love heart' },
  { emoji: '💛', name: 'Yellow heart', keywords: 'love heart' },
  { emoji: '💚', name: 'Green heart', keywords: 'love heart' },
  { emoji: '💙', name: 'Blue heart', keywords: 'love heart' },
  { emoji: '🩵', name: 'Light blue heart', keywords: 'love heart' },
  { emoji: '💜', name: 'Purple heart', keywords: 'love heart' },
  { emoji: '🤎', name: 'Brown heart', keywords: 'love heart' },
  { emoji: '🖤', name: 'Black heart', keywords: 'love heart' },
  { emoji: '🩶', name: 'Gray heart', keywords: 'love heart' },
  { emoji: '🤍', name: 'White heart', keywords: 'love heart' },
  { emoji: '💯', name: 'Hundred', keywords: '100 perfect' },
  { emoji: '💢', name: 'Anger symbol', keywords: 'angry mad' },
  { emoji: '💥', name: 'Collision', keywords: 'boom explode' },
  { emoji: '💫', name: 'Dizzy', keywords: 'sparkle star' },
  { emoji: '💦', name: 'Sweat droplets', keywords: 'water sweat' },
  { emoji: '💨', name: 'Dashing away', keywords: 'fast smoke' },
  { emoji: '🕳️', name: 'Hole', keywords: 'hole' },
  { emoji: '💬', name: 'Speech balloon', keywords: 'comment chat' },
  { emoji: '👋', name: 'Waving hand', keywords: 'wave hello bye' },
  { emoji: '🤚', name: 'Raised back hand', keywords: 'hand stop' },
  { emoji: '🖐️', name: 'Hand fingers splayed', keywords: 'hand high five' },
  { emoji: '✋', name: 'Raised hand', keywords: 'hand stop' },
  { emoji: '🖖', name: 'Vulcan salute', keywords: 'hand star trek' },
  { emoji: '🫱', name: 'Rightwards hand', keywords: 'hand right' },
  { emoji: '🫲', name: 'Leftwards hand', keywords: 'hand left' },
  { emoji: '👌', name: 'OK hand', keywords: 'ok perfect hand' },
  { emoji: '🤌', name: 'Pinched fingers', keywords: 'hand chef' },
  { emoji: '🤏', name: 'Pinching hand', keywords: 'small hand' },
  { emoji: '✌️', name: 'Victory hand', keywords: 'peace win' },
  { emoji: '🤞', name: 'Crossed fingers', keywords: 'luck hope' },
  { emoji: '🫰', name: 'Hand with index thumb crossed', keywords: 'heart money' },
  { emoji: '🤟', name: 'Love you hand', keywords: 'love hand' },
  { emoji: '🤘', name: 'Rock hand', keywords: 'rock music' },
  { emoji: '🤙', name: 'Call me hand', keywords: 'call phone' },
  { emoji: '👈', name: 'Point left', keywords: 'point left' },
  { emoji: '👉', name: 'Point right', keywords: 'point right' },
  { emoji: '👆', name: 'Point up', keywords: 'point up' },
  { emoji: '👇', name: 'Point down', keywords: 'point down' },
  { emoji: '☝️', name: 'Index up', keywords: 'point up' },
  { emoji: '👍', name: 'Thumbs up', keywords: 'like yes approve' },
  { emoji: '👎', name: 'Thumbs down', keywords: 'dislike no' },
  { emoji: '✊', name: 'Raised fist', keywords: 'fist power' },
  { emoji: '👊', name: 'Oncoming fist', keywords: 'fist bump' },
  { emoji: '🤛', name: 'Left fist', keywords: 'fist bump' },
  { emoji: '🤜', name: 'Right fist', keywords: 'fist bump' },
  { emoji: '👏', name: 'Clapping hands', keywords: 'clap applause' },
  { emoji: '🙌', name: 'Raising hands', keywords: 'celebrate hands' },
  { emoji: '🫶', name: 'Heart hands', keywords: 'love hands' },
  { emoji: '👐', name: 'Open hands', keywords: 'hands open' },
  { emoji: '🤲', name: 'Palms up', keywords: 'hands pray' },
  { emoji: '🤝', name: 'Handshake', keywords: 'deal agreement' },
  { emoji: '🙏', name: 'Folded hands', keywords: 'pray please thanks' },
  { emoji: '✍️', name: 'Writing hand', keywords: 'write pen' },
  { emoji: '💪', name: 'Flexed biceps', keywords: 'strong muscle' },
  { emoji: '🦾', name: 'Mechanical arm', keywords: 'strong robot' },
  { emoji: '🦿', name: 'Mechanical leg', keywords: 'leg robot' },
  { emoji: '🦵', name: 'Leg', keywords: 'leg' },
  { emoji: '👀', name: 'Eyes', keywords: 'look see watch' },
  { emoji: '👁️', name: 'Eye', keywords: 'look see' },
  { emoji: '🧠', name: 'Brain', keywords: 'think smart' },
  { emoji: '🫀', name: 'Heart organ', keywords: 'heart body' },
  { emoji: '🫁', name: 'Lungs', keywords: 'breathe' },
  { emoji: '🦷', name: 'Tooth', keywords: 'tooth dental' },
  { emoji: '🦴', name: 'Bone', keywords: 'bone' },
  { emoji: '👤', name: 'Bust silhouette', keywords: 'person user' },
  { emoji: '👥', name: 'Busts silhouettes', keywords: 'people users' },
  { emoji: '🗣️', name: 'Speaking head', keywords: 'talk speak' },
  { emoji: '👶', name: 'Baby', keywords: 'baby child' },
  { emoji: '🧒', name: 'Child', keywords: 'child kid' },
  { emoji: '👦', name: 'Boy', keywords: 'boy child' },
  { emoji: '👧', name: 'Girl', keywords: 'girl child' },
  { emoji: '🧑', name: 'Person', keywords: 'person adult' },
  { emoji: '👱', name: 'Blond person', keywords: 'person blond' },
  { emoji: '👨', name: 'Man', keywords: 'man person' },
  { emoji: '🧔', name: 'Bearded person', keywords: 'beard person' },
  { emoji: '👩', name: 'Woman', keywords: 'woman person' },
  { emoji: '🧓', name: 'Older person', keywords: 'older elder' },
  { emoji: '👴', name: 'Old man', keywords: 'older man' },
  { emoji: '👵', name: 'Old woman', keywords: 'older woman' },
  { emoji: '🙍', name: 'Person frowning', keywords: 'person sad' },
  { emoji: '🙎', name: 'Person pouting', keywords: 'person mad' },
  { emoji: '🙅', name: 'Person gesturing no', keywords: 'no stop' },
  { emoji: '🙆', name: 'Person gesturing ok', keywords: 'ok yes' },
  { emoji: '💁', name: 'Person tipping hand', keywords: 'info help' },
  { emoji: '🙋', name: 'Person raising hand', keywords: 'question hand' },
  { emoji: '🧏', name: 'Deaf person', keywords: 'deaf person' },
  { emoji: '🙇', name: 'Person bowing', keywords: 'bow thanks' },
  { emoji: '🤦', name: 'Face palm', keywords: 'facepalm mistake' },
  { emoji: '🤷', name: 'Shrug', keywords: 'shrug idk' },
  { emoji: '👮', name: 'Police officer', keywords: 'police officer' },
  { emoji: '🕵️', name: 'Detective', keywords: 'detective spy' },
  { emoji: '💂', name: 'Guard', keywords: 'guard' },
  { emoji: '🥷', name: 'Ninja', keywords: 'ninja stealth' },
  { emoji: '👷', name: 'Construction worker', keywords: 'worker construction' },
  { emoji: '🧑‍⚕️', name: 'Health worker', keywords: 'doctor nurse medical' },
  { emoji: '🧑‍🌾', name: 'Farmer', keywords: 'farmer' },
  { emoji: '🧑‍🍳', name: 'Cook', keywords: 'chef cook food' },
  { emoji: '🧑‍🎓', name: 'Student', keywords: 'student school' },
  { emoji: '🧑‍🎤', name: 'Singer', keywords: 'music singer' },
  { emoji: '🧑‍🏫', name: 'Teacher', keywords: 'teacher school' },
  { emoji: '🧑‍🏭', name: 'Factory worker', keywords: 'factory worker' },
  { emoji: '🧑‍💻', name: 'Technologist', keywords: 'computer tech' },
  { emoji: '🧑‍💼', name: 'Office worker', keywords: 'business work' },
  { emoji: '🧑‍🔧', name: 'Mechanic', keywords: 'mechanic wrench car' },
  { emoji: '🧑‍🔬', name: 'Scientist', keywords: 'science' },
  { emoji: '🧑‍🎨', name: 'Artist', keywords: 'art paint' },
  { emoji: '🧑‍🚒', name: 'Firefighter', keywords: 'fire rescue' },
  { emoji: '🧑‍✈️', name: 'Pilot', keywords: 'pilot plane' },
  { emoji: '🧑‍🚀', name: 'Astronaut', keywords: 'space astronaut' },
  { emoji: '🧑‍⚖️', name: 'Judge', keywords: 'judge law' },
  { emoji: '👰', name: 'Person with veil', keywords: 'wedding bride' },
  { emoji: '🤵', name: 'Person in tuxedo', keywords: 'wedding tuxedo' },
  { emoji: '🦸', name: 'Superhero', keywords: 'hero' },
  { emoji: '🦹', name: 'Supervillain', keywords: 'villain' },
  { emoji: '🧙', name: 'Mage', keywords: 'wizard magic' },
  { emoji: '🧚', name: 'Fairy', keywords: 'fairy magic' },
  { emoji: '🧛', name: 'Vampire', keywords: 'vampire' },
  { emoji: '🧜', name: 'Merperson', keywords: 'mermaid' },
  { emoji: '🧝', name: 'Elf', keywords: 'elf' },
  { emoji: '🧞', name: 'Genie', keywords: 'genie wish' },
  { emoji: '🧟', name: 'Zombie', keywords: 'zombie' },
  { emoji: '💆', name: 'Massage', keywords: 'massage relax' },
  { emoji: '💇', name: 'Haircut', keywords: 'haircut hair' },
  { emoji: '🚶', name: 'Walking', keywords: 'walk' },
  { emoji: '🧍', name: 'Standing', keywords: 'stand' },
  { emoji: '🧎', name: 'Kneeling', keywords: 'kneel' },
  { emoji: '🏃', name: 'Running', keywords: 'run fast' },
  { emoji: '💃', name: 'Dancing woman', keywords: 'dance party' },
  { emoji: '🕺', name: 'Dancing man', keywords: 'dance party' },
  { emoji: '🕴️', name: 'Suit levitating', keywords: 'business' },
  { emoji: '👯', name: 'People with bunny ears', keywords: 'party dance' },
  { emoji: '🧖', name: 'Person in steamy room', keywords: 'spa relax' },
  { emoji: '🧗', name: 'Climbing', keywords: 'climb sport' },
  { emoji: '🤺', name: 'Fencer', keywords: 'fencing sport' },
  { emoji: '🏇', name: 'Horse racing', keywords: 'horse race' },
  { emoji: '⛷️', name: 'Skier', keywords: 'ski snow sport' },
  { emoji: '🏂', name: 'Snowboarder', keywords: 'snowboard snow sport' },
  { emoji: '🏌️', name: 'Golfer', keywords: 'golf sport' },
  { emoji: '🏄', name: 'Surfer', keywords: 'surf water sport' },
  { emoji: '🚣', name: 'Rowing boat', keywords: 'boat row sport' },
  { emoji: '🏊', name: 'Swimming', keywords: 'swim water sport' },
  { emoji: '⛹️', name: 'Bouncing ball', keywords: 'basketball sport' },
  { emoji: '🏋️', name: 'Weight lifting', keywords: 'gym lift sport' },
  { emoji: '🚴', name: 'Biking', keywords: 'bike bicycle sport' },
  { emoji: '🚵', name: 'Mountain biking', keywords: 'bike mountain sport' },
  { emoji: '🤸', name: 'Cartwheel', keywords: 'gymnastics' },
  { emoji: '🤼', name: 'Wrestling', keywords: 'wrestle sport' },
  { emoji: '🤽', name: 'Water polo', keywords: 'water sport' },
  { emoji: '🤾', name: 'Handball', keywords: 'handball sport' },
  { emoji: '🤹', name: 'Juggling', keywords: 'juggle circus' },
  { emoji: '🧘', name: 'Lotus position', keywords: 'yoga meditate' },
  { emoji: '🛀', name: 'Bath', keywords: 'bath relax' },
  { emoji: '🛌', name: 'Bed', keywords: 'sleep bed' },
  { emoji: '🐶', name: 'Dog face', keywords: 'dog pet animal' },
  { emoji: '🐱', name: 'Cat face', keywords: 'cat pet animal' },
  { emoji: '🐭', name: 'Mouse face', keywords: 'mouse animal' },
  { emoji: '🐹', name: 'Hamster', keywords: 'hamster pet animal' },
  { emoji: '🐰', name: 'Rabbit face', keywords: 'rabbit bunny animal' },
  { emoji: '🦊', name: 'Fox', keywords: 'fox animal' },
  { emoji: '🐻', name: 'Bear', keywords: 'bear animal' },
  { emoji: '🐼', name: 'Panda', keywords: 'panda animal' },
  { emoji: '🐻‍❄️', name: 'Polar bear', keywords: 'bear animal' },
  { emoji: '🐨', name: 'Koala', keywords: 'koala animal' },
  { emoji: '🐯', name: 'Tiger face', keywords: 'tiger animal' },
  { emoji: '🦁', name: 'Lion', keywords: 'lion animal' },
  { emoji: '🐮', name: 'Cow face', keywords: 'cow animal' },
  { emoji: '🐷', name: 'Pig face', keywords: 'pig animal' },
  { emoji: '🐸', name: 'Frog', keywords: 'frog animal' },
  { emoji: '🐵', name: 'Monkey face', keywords: 'monkey animal' },
  { emoji: '🐔', name: 'Chicken', keywords: 'chicken bird animal' },
  { emoji: '🐧', name: 'Penguin', keywords: 'penguin bird animal' },
  { emoji: '🐦', name: 'Bird', keywords: 'bird animal' },
  { emoji: '🐤', name: 'Baby chick', keywords: 'chick bird animal' },
  { emoji: '🦆', name: 'Duck', keywords: 'duck bird animal' },
  { emoji: '🦅', name: 'Eagle', keywords: 'eagle bird animal' },
  { emoji: '🦉', name: 'Owl', keywords: 'owl bird animal' },
  { emoji: '🦇', name: 'Bat', keywords: 'bat animal' },
  { emoji: '🐺', name: 'Wolf', keywords: 'wolf animal' },
  { emoji: '🐗', name: 'Boar', keywords: 'boar animal' },
  { emoji: '🐴', name: 'Horse face', keywords: 'horse animal' },
  { emoji: '🦄', name: 'Unicorn', keywords: 'unicorn animal' },
  { emoji: '🐝', name: 'Honeybee', keywords: 'bee insect' },
  { emoji: '🪲', name: 'Beetle', keywords: 'bug insect' },
  { emoji: '🦋', name: 'Butterfly', keywords: 'butterfly insect' },
  { emoji: '🐌', name: 'Snail', keywords: 'snail animal' },
  { emoji: '🐞', name: 'Lady beetle', keywords: 'ladybug insect' },
  { emoji: '🐜', name: 'Ant', keywords: 'ant insect' },
  { emoji: '🪰', name: 'Fly', keywords: 'fly insect' },
  { emoji: '🪱', name: 'Worm', keywords: 'worm animal' },
  { emoji: '🦗', name: 'Cricket', keywords: 'cricket insect' },
  { emoji: '🕷️', name: 'Spider', keywords: 'spider bug' },
  { emoji: '🦂', name: 'Scorpion', keywords: 'scorpion animal' },
  { emoji: '🐢', name: 'Turtle', keywords: 'turtle animal' },
  { emoji: '🐍', name: 'Snake', keywords: 'snake animal' },
  { emoji: '🦎', name: 'Lizard', keywords: 'lizard animal' },
  { emoji: '🦖', name: 'T-Rex', keywords: 'dinosaur trex animal' },
  { emoji: '🦕', name: 'Sauropod', keywords: 'dinosaur animal' },
  { emoji: '🐙', name: 'Octopus', keywords: 'octopus sea animal' },
  { emoji: '🦑', name: 'Squid', keywords: 'squid sea animal' },
  { emoji: '🦐', name: 'Shrimp', keywords: 'shrimp food sea' },
  { emoji: '🦞', name: 'Lobster', keywords: 'lobster food sea' },
  { emoji: '🦀', name: 'Crab', keywords: 'crab food sea' },
  { emoji: '🐡', name: 'Blowfish', keywords: 'fish sea' },
  { emoji: '🐠', name: 'Tropical fish', keywords: 'fish sea' },
  { emoji: '🐟', name: 'Fish', keywords: 'fish sea' },
  { emoji: '🐬', name: 'Dolphin', keywords: 'dolphin sea' },
  { emoji: '🐳', name: 'Whale spout', keywords: 'whale sea' },
  { emoji: '🐋', name: 'Whale', keywords: 'whale sea' },
  { emoji: '🦈', name: 'Shark', keywords: 'shark sea' },
  { emoji: '🦭', name: 'Seal', keywords: 'seal sea' },
  { emoji: '🐊', name: 'Crocodile', keywords: 'crocodile animal' },
  { emoji: '🐅', name: 'Tiger', keywords: 'tiger animal' },
  { emoji: '🐆', name: 'Leopard', keywords: 'leopard animal' },
  { emoji: '🦓', name: 'Zebra', keywords: 'zebra animal' },
  { emoji: '🦍', name: 'Gorilla', keywords: 'gorilla animal' },
  { emoji: '🦧', name: 'Orangutan', keywords: 'orangutan animal' },
  { emoji: '🐘', name: 'Elephant', keywords: 'elephant animal' },
  { emoji: '🦛', name: 'Hippopotamus', keywords: 'hippo animal' },
  { emoji: '🦏', name: 'Rhinoceros', keywords: 'rhino animal' },
  { emoji: '🐪', name: 'Camel', keywords: 'camel animal' },
  { emoji: '🐫', name: 'Two-hump camel', keywords: 'camel animal' },
  { emoji: '🦒', name: 'Giraffe', keywords: 'giraffe animal' },
  { emoji: '🦘', name: 'Kangaroo', keywords: 'kangaroo animal' },
  { emoji: '🦬', name: 'Bison', keywords: 'bison animal' },
  { emoji: '🐃', name: 'Water buffalo', keywords: 'buffalo animal' },
  { emoji: '🐂', name: 'Ox', keywords: 'ox animal' },
  { emoji: '🐄', name: 'Cow', keywords: 'cow animal' },
  { emoji: '🐎', name: 'Horse', keywords: 'horse animal' },
  { emoji: '🐖', name: 'Pig', keywords: 'pig animal' },
  { emoji: '🐏', name: 'Ram', keywords: 'ram sheep animal' },
  { emoji: '🐑', name: 'Ewe', keywords: 'sheep animal' },
  { emoji: '🦙', name: 'Llama', keywords: 'llama animal' },
  { emoji: '🐐', name: 'Goat', keywords: 'goat animal' },
  { emoji: '🦌', name: 'Deer', keywords: 'deer animal' },
  { emoji: '🐕', name: 'Dog', keywords: 'dog pet animal' },
  { emoji: '🐩', name: 'Poodle', keywords: 'dog pet animal' },
  { emoji: '🦮', name: 'Guide dog', keywords: 'dog service animal' },
  { emoji: '🐕‍🦺', name: 'Service dog', keywords: 'dog service animal' },
  { emoji: '🐈', name: 'Cat', keywords: 'cat pet animal' },
  { emoji: '🐈‍⬛', name: 'Black cat', keywords: 'cat pet animal' },
  { emoji: '🪶', name: 'Feather', keywords: 'feather bird' },
  { emoji: '🐓', name: 'Rooster', keywords: 'rooster chicken bird' },
  { emoji: '🦃', name: 'Turkey', keywords: 'turkey bird' },
  { emoji: '🦚', name: 'Peacock', keywords: 'peacock bird' },
  { emoji: '🦜', name: 'Parrot', keywords: 'parrot bird' },
  { emoji: '🦢', name: 'Swan', keywords: 'swan bird' },
  { emoji: '🦩', name: 'Flamingo', keywords: 'flamingo bird' },
  { emoji: '🕊️', name: 'Dove', keywords: 'dove bird peace' },
  { emoji: '🐇', name: 'Rabbit', keywords: 'rabbit bunny animal' },
  { emoji: '🦨', name: 'Skunk', keywords: 'animal' },
  { emoji: '🦡', name: 'Badger', keywords: 'animal' },
  { emoji: '🦫', name: 'Beaver', keywords: 'animal' },
  { emoji: '🦦', name: 'Otter', keywords: 'animal' },
  { emoji: '🦥', name: 'Sloth', keywords: 'animal' },
  { emoji: '🐁', name: 'Mouse', keywords: 'mouse animal' },
  { emoji: '🐀', name: 'Rat', keywords: 'rat animal' },
  { emoji: '🐿️', name: 'Chipmunk', keywords: 'chipmunk animal' },
  { emoji: '🦔', name: 'Hedgehog', keywords: 'hedgehog animal' },
  { emoji: '🐾', name: 'Paw prints', keywords: 'paw pet animal' },
  { emoji: '🐉', name: 'Dragon', keywords: 'dragon animal' },
  { emoji: '🐲', name: 'Dragon face', keywords: 'dragon animal' },
  { emoji: '🌵', name: 'Cactus', keywords: 'plant desert' },
  { emoji: '🎄', name: 'Christmas tree', keywords: 'christmas tree holiday' },
  { emoji: '🌲', name: 'Evergreen tree', keywords: 'tree plant' },
  { emoji: '🌳', name: 'Deciduous tree', keywords: 'tree plant' },
  { emoji: '🌴', name: 'Palm tree', keywords: 'tree tropical' },
  { emoji: '🪵', name: 'Wood', keywords: 'wood log' },
  { emoji: '🌱', name: 'Seedling', keywords: 'plant grow' },
  { emoji: '🌿', name: 'Herb', keywords: 'plant leaf' },
  { emoji: '☘️', name: 'Shamrock', keywords: 'plant lucky' },
  { emoji: '🍀', name: 'Four leaf clover', keywords: 'lucky clover' },
  { emoji: '🎍', name: 'Pine decoration', keywords: 'plant decoration' },
  { emoji: '🪴', name: 'Potted plant', keywords: 'plant' },
  { emoji: '🎋', name: 'Tanabata tree', keywords: 'tree decoration' },
  { emoji: '🍃', name: 'Leaf fluttering', keywords: 'leaf wind' },
  { emoji: '🍂', name: 'Fallen leaf', keywords: 'leaf fall' },
  { emoji: '🍁', name: 'Maple leaf', keywords: 'leaf fall' },
  { emoji: '🍄', name: 'Mushroom', keywords: 'mushroom food' },
  { emoji: '🐚', name: 'Seashell', keywords: 'shell beach' },
  { emoji: '🪸', name: 'Coral', keywords: 'coral sea' },
  { emoji: '🪨', name: 'Rock', keywords: 'rock stone' },
  { emoji: '🌾', name: 'Sheaf of rice', keywords: 'plant grain' },
  { emoji: '💐', name: 'Bouquet', keywords: 'flowers' },
  { emoji: '🌷', name: 'Tulip', keywords: 'flower' },
  { emoji: '🌹', name: 'Rose', keywords: 'flower love' },
  { emoji: '🥀', name: 'Wilted flower', keywords: 'flower sad' },
  { emoji: '🌺', name: 'Hibiscus', keywords: 'flower tropical' },
  { emoji: '🌸', name: 'Cherry blossom', keywords: 'flower blossom' },
  { emoji: '🌼', name: 'Blossom', keywords: 'flower' },
  { emoji: '🌻', name: 'Sunflower', keywords: 'flower sun' },
  { emoji: '🌞', name: 'Sun face', keywords: 'sun weather' },
  { emoji: '🌝', name: 'Full moon face', keywords: 'moon night' },
  { emoji: '🌛', name: 'First quarter moon face', keywords: 'moon night' },
  { emoji: '🌜', name: 'Last quarter moon face', keywords: 'moon night' },
  { emoji: '🌚', name: 'New moon face', keywords: 'moon night' },
  { emoji: '🌕', name: 'Full moon', keywords: 'moon night' },
  { emoji: '🌖', name: 'Waning gibbous moon', keywords: 'moon night' },
  { emoji: '🌗', name: 'Last quarter moon', keywords: 'moon night' },
  { emoji: '🌘', name: 'Waning crescent moon', keywords: 'moon night' },
  { emoji: '🌑', name: 'New moon', keywords: 'moon night' },
  { emoji: '🌒', name: 'Waxing crescent moon', keywords: 'moon night' },
  { emoji: '🌓', name: 'First quarter moon', keywords: 'moon night' },
  { emoji: '🌔', name: 'Waxing gibbous moon', keywords: 'moon night' },
  { emoji: '🌙', name: 'Crescent moon', keywords: 'moon night' },
  { emoji: '🌎', name: 'Globe Americas', keywords: 'earth world' },
  { emoji: '🌍', name: 'Globe Europe Africa', keywords: 'earth world' },
  { emoji: '🌏', name: 'Globe Asia Australia', keywords: 'earth world' },
  { emoji: '🪐', name: 'Ringed planet', keywords: 'planet space' },
  { emoji: '💫', name: 'Dizzy star', keywords: 'star sparkle' },
  { emoji: '⭐', name: 'Star', keywords: 'star favorite' },
  { emoji: '🌟', name: 'Glowing star', keywords: 'star sparkle' },
  { emoji: '✨', name: 'Sparkles', keywords: 'sparkle shine' },
  { emoji: '⚡', name: 'Lightning', keywords: 'bolt electric' },
  { emoji: '☄️', name: 'Comet', keywords: 'space comet' },
  { emoji: '💥', name: 'Boom', keywords: 'boom explosion' },
  { emoji: '🔥', name: 'Fire', keywords: 'fire hot' },
  { emoji: '🌪️', name: 'Tornado', keywords: 'weather storm' },
  { emoji: '🌈', name: 'Rainbow', keywords: 'rainbow weather' },
  { emoji: '☀️', name: 'Sun', keywords: 'sun weather' },
  { emoji: '🌤️', name: 'Sun behind small cloud', keywords: 'weather' },
  { emoji: '⛅', name: 'Sun behind cloud', keywords: 'weather' },
  { emoji: '🌥️', name: 'Sun behind large cloud', keywords: 'weather' },
  { emoji: '☁️', name: 'Cloud', keywords: 'weather' },
  { emoji: '🌦️', name: 'Sun behind rain cloud', keywords: 'weather rain' },
  { emoji: '🌧️', name: 'Rain cloud', keywords: 'weather rain' },
  { emoji: '⛈️', name: 'Thunder cloud rain', keywords: 'storm rain' },
  { emoji: '🌩️', name: 'Lightning cloud', keywords: 'storm lightning' },
  { emoji: '🌨️', name: 'Snow cloud', keywords: 'weather snow' },
  { emoji: '❄️', name: 'Snowflake', keywords: 'snow cold' },
  { emoji: '☃️', name: 'Snowman', keywords: 'snow winter' },
  { emoji: '⛄', name: 'Snowman no snow', keywords: 'snow winter' },
  { emoji: '🌬️', name: 'Wind face', keywords: 'wind weather' },
  { emoji: '💨', name: 'Dash', keywords: 'fast wind' },
  { emoji: '💧', name: 'Droplet', keywords: 'water drop' },
  { emoji: '💦', name: 'Sweat drops', keywords: 'water sweat' },
  { emoji: '☔', name: 'Umbrella rain', keywords: 'rain umbrella' },
  { emoji: '☂️', name: 'Umbrella', keywords: 'umbrella rain' },
  { emoji: '🌊', name: 'Water wave', keywords: 'water wave ocean' },
  { emoji: '🍏', name: 'Green apple', keywords: 'apple fruit food' },
  { emoji: '🍎', name: 'Red apple', keywords: 'apple fruit food' },
  { emoji: '🍐', name: 'Pear', keywords: 'pear fruit food' },
  { emoji: '🍊', name: 'Tangerine', keywords: 'orange fruit food' },
  { emoji: '🍋', name: 'Lemon', keywords: 'lemon fruit food' },
  { emoji: '🍌', name: 'Banana', keywords: 'banana fruit food' },
  { emoji: '🍉', name: 'Watermelon', keywords: 'watermelon fruit food' },
  { emoji: '🍇', name: 'Grapes', keywords: 'grapes fruit food' },
  { emoji: '🍓', name: 'Strawberry', keywords: 'strawberry fruit food' },
  { emoji: '🫐', name: 'Blueberries', keywords: 'blueberries fruit food' },
  { emoji: '🍈', name: 'Melon', keywords: 'melon fruit food' },
  { emoji: '🍒', name: 'Cherries', keywords: 'cherries fruit food' },
  { emoji: '🍑', name: 'Peach', keywords: 'peach fruit food' },
  { emoji: '🥭', name: 'Mango', keywords: 'mango fruit food' },
  { emoji: '🍍', name: 'Pineapple', keywords: 'pineapple fruit food' },
  { emoji: '🥥', name: 'Coconut', keywords: 'coconut fruit food' },
  { emoji: '🥝', name: 'Kiwi', keywords: 'kiwi fruit food' },
  { emoji: '🍅', name: 'Tomato', keywords: 'tomato food' },
  { emoji: '🍆', name: 'Eggplant', keywords: 'eggplant food' },
  { emoji: '🥑', name: 'Avocado', keywords: 'avocado food' },
  { emoji: '🥦', name: 'Broccoli', keywords: 'broccoli food' },
  { emoji: '🥬', name: 'Leafy green', keywords: 'lettuce greens food' },
  { emoji: '🥒', name: 'Cucumber', keywords: 'cucumber food' },
  { emoji: '🌶️', name: 'Hot pepper', keywords: 'pepper spicy food' },
  { emoji: '🫑', name: 'Bell pepper', keywords: 'pepper food' },
  { emoji: '🌽', name: 'Corn', keywords: 'corn food' },
  { emoji: '🥕', name: 'Carrot', keywords: 'carrot food' },
  { emoji: '🫒', name: 'Olive', keywords: 'olive food' },
  { emoji: '🧄', name: 'Garlic', keywords: 'garlic food' },
  { emoji: '🧅', name: 'Onion', keywords: 'onion food' },
  { emoji: '🥔', name: 'Potato', keywords: 'potato food' },
  { emoji: '🍠', name: 'Roasted sweet potato', keywords: 'potato food' },
  { emoji: '🥐', name: 'Croissant', keywords: 'bread food' },
  { emoji: '🥯', name: 'Bagel', keywords: 'bagel bread food' },
  { emoji: '🍞', name: 'Bread', keywords: 'bread food' },
  { emoji: '🥖', name: 'Baguette', keywords: 'bread food' },
  { emoji: '🥨', name: 'Pretzel', keywords: 'pretzel food' },
  { emoji: '🧀', name: 'Cheese', keywords: 'cheese food' },
  { emoji: '🥚', name: 'Egg', keywords: 'egg food' },
  { emoji: '🍳', name: 'Cooking', keywords: 'egg pan food' },
  { emoji: '🧈', name: 'Butter', keywords: 'butter food' },
  { emoji: '🥞', name: 'Pancakes', keywords: 'pancakes food' },
  { emoji: '🧇', name: 'Waffle', keywords: 'waffle food' },
  { emoji: '🥓', name: 'Bacon', keywords: 'bacon food' },
  { emoji: '🥩', name: 'Cut of meat', keywords: 'meat steak food' },
  { emoji: '🍗', name: 'Poultry leg', keywords: 'chicken food' },
  { emoji: '🍖', name: 'Meat on bone', keywords: 'meat food' },
  { emoji: '🌭', name: 'Hot dog', keywords: 'hotdog food' },
  { emoji: '🍔', name: 'Hamburger', keywords: 'burger food' },
  { emoji: '🍟', name: 'Fries', keywords: 'fries food' },
  { emoji: '🍕', name: 'Pizza', keywords: 'pizza food' },
  { emoji: '🫓', name: 'Flatbread', keywords: 'bread food' },
  { emoji: '🥪', name: 'Sandwich', keywords: 'sandwich food' },
  { emoji: '🥙', name: 'Stuffed flatbread', keywords: 'wrap food' },
  { emoji: '🧆', name: 'Falafel', keywords: 'falafel food' },
  { emoji: '🌮', name: 'Taco', keywords: 'taco food' },
  { emoji: '🌯', name: 'Burrito', keywords: 'burrito food' },
  { emoji: '🫔', name: 'Tamale', keywords: 'tamale food' },
  { emoji: '🥗', name: 'Green salad', keywords: 'salad food' },
  { emoji: '🥘', name: 'Shallow pan food', keywords: 'paella food' },
  { emoji: '🫕', name: 'Fondue', keywords: 'fondue food' },
  { emoji: '🥫', name: 'Canned food', keywords: 'can food' },
  { emoji: '🍝', name: 'Spaghetti', keywords: 'pasta food' },
  { emoji: '🍜', name: 'Steaming bowl', keywords: 'noodles ramen food' },
  { emoji: '🍲', name: 'Pot of food', keywords: 'soup stew food' },
  { emoji: '🍛', name: 'Curry rice', keywords: 'curry rice food' },
  { emoji: '🍣', name: 'Sushi', keywords: 'sushi food' },
  { emoji: '🍱', name: 'Bento box', keywords: 'bento food' },
  { emoji: '🥟', name: 'Dumpling', keywords: 'dumpling food' },
  { emoji: '🦪', name: 'Oyster', keywords: 'oyster food' },
  { emoji: '🍤', name: 'Fried shrimp', keywords: 'shrimp food' },
  { emoji: '🍙', name: 'Rice ball', keywords: 'rice food' },
  { emoji: '🍚', name: 'Cooked rice', keywords: 'rice food' },
  { emoji: '🍘', name: 'Rice cracker', keywords: 'rice food' },
  { emoji: '🍥', name: 'Fish cake', keywords: 'fish food' },
  { emoji: '🥠', name: 'Fortune cookie', keywords: 'cookie food' },
  { emoji: '🥮', name: 'Moon cake', keywords: 'cake food' },
  { emoji: '🍢', name: 'Oden', keywords: 'oden food' },
  { emoji: '🍡', name: 'Dango', keywords: 'dango food' },
  { emoji: '🍧', name: 'Shaved ice', keywords: 'ice dessert food' },
  { emoji: '🍨', name: 'Ice cream', keywords: 'ice cream dessert' },
  { emoji: '🍦', name: 'Soft ice cream', keywords: 'ice cream dessert' },
  { emoji: '🥧', name: 'Pie', keywords: 'pie dessert food' },
  { emoji: '🧁', name: 'Cupcake', keywords: 'cupcake dessert' },
  { emoji: '🍰', name: 'Shortcake', keywords: 'cake dessert' },
  { emoji: '🎂', name: 'Birthday cake', keywords: 'birthday cake dessert' },
  { emoji: '🍮', name: 'Custard', keywords: 'custard dessert' },
  { emoji: '🍭', name: 'Lollipop', keywords: 'candy dessert' },
  { emoji: '🍬', name: 'Candy', keywords: 'candy dessert' },
  { emoji: '🍫', name: 'Chocolate bar', keywords: 'chocolate dessert' },
  { emoji: '🍿', name: 'Popcorn', keywords: 'popcorn food' },
  { emoji: '🍩', name: 'Doughnut', keywords: 'donut dessert' },
  { emoji: '🍪', name: 'Cookie', keywords: 'cookie dessert' },
  { emoji: '🌰', name: 'Chestnut', keywords: 'nut food' },
  { emoji: '🥜', name: 'Peanuts', keywords: 'peanuts food' },
  { emoji: '🍯', name: 'Honey pot', keywords: 'honey sweet' },
  { emoji: '🥛', name: 'Glass of milk', keywords: 'milk drink' },
  { emoji: '🍼', name: 'Baby bottle', keywords: 'bottle drink' },
  { emoji: '☕', name: 'Hot beverage', keywords: 'coffee tea drink' },
  { emoji: '🫖', name: 'Teapot', keywords: 'tea drink' },
  { emoji: '🍵', name: 'Teacup', keywords: 'tea drink' },
  { emoji: '🍶', name: 'Sake', keywords: 'sake drink' },
  { emoji: '🍾', name: 'Champagne', keywords: 'champagne bottle' },
  { emoji: '🍷', name: 'Wine glass', keywords: 'wine drink' },
  { emoji: '🍸', name: 'Cocktail glass', keywords: 'cocktail drink' },
  { emoji: '🍹', name: 'Tropical drink', keywords: 'cocktail drink' },
  { emoji: '🍺', name: 'Beer mug', keywords: 'beer drink' },
  { emoji: '🍻', name: 'Clinking beers', keywords: 'beer cheers' },
  { emoji: '🥂', name: 'Clinking glasses', keywords: 'cheers drink' },
  { emoji: '🥃', name: 'Tumbler glass', keywords: 'whiskey drink' },
  { emoji: '🥤', name: 'Cup with straw', keywords: 'soda drink' },
  { emoji: '🧋', name: 'Bubble tea', keywords: 'boba tea drink' },
  { emoji: '🧃', name: 'Beverage box', keywords: 'juice drink' },
  { emoji: '🧉', name: 'Mate', keywords: 'mate drink' },
  { emoji: '🧊', name: 'Ice', keywords: 'ice cold' },
  { emoji: '🥢', name: 'Chopsticks', keywords: 'chopsticks utensil' },
  { emoji: '🍽️', name: 'Plate cutlery', keywords: 'plate food' },
  { emoji: '🍴', name: 'Fork and knife', keywords: 'utensils food' },
  { emoji: '🥄', name: 'Spoon', keywords: 'spoon utensil' },
  { emoji: '🔪', name: 'Kitchen knife', keywords: 'knife utensil' },
  { emoji: '🏺', name: 'Amphora', keywords: 'vase' },
  { emoji: '🌍', name: 'World map', keywords: 'world earth travel' },
  { emoji: '🗺️', name: 'Map', keywords: 'map travel' },
  { emoji: '🧭', name: 'Compass', keywords: 'compass travel' },
  { emoji: '🏔️', name: 'Snow mountain', keywords: 'mountain travel' },
  { emoji: '⛰️', name: 'Mountain', keywords: 'mountain travel' },
  { emoji: '🌋', name: 'Volcano', keywords: 'volcano travel' },
  { emoji: '🗻', name: 'Mount Fuji', keywords: 'mountain travel' },
  { emoji: '🏕️', name: 'Camping', keywords: 'camping travel' },
  { emoji: '🏖️', name: 'Beach umbrella', keywords: 'beach travel' },
  { emoji: '🏜️', name: 'Desert', keywords: 'desert travel' },
  { emoji: '🏝️', name: 'Desert island', keywords: 'island beach' },
  { emoji: '🏞️', name: 'National park', keywords: 'park travel' },
  { emoji: '🏟️', name: 'Stadium', keywords: 'stadium sport' },
  { emoji: '🏛️', name: 'Classical building', keywords: 'building' },
  { emoji: '🏗️', name: 'Building construction', keywords: 'construction' },
  { emoji: '🧱', name: 'Brick', keywords: 'brick building' },
  { emoji: '🪨', name: 'Rock stone', keywords: 'stone rock' },
  { emoji: '🪵', name: 'Log wood', keywords: 'wood log' },
  { emoji: '🛖', name: 'Hut', keywords: 'hut building' },
  { emoji: '🏘️', name: 'Houses', keywords: 'house neighborhood' },
  { emoji: '🏚️', name: 'Derelict house', keywords: 'house old' },
  { emoji: '🏠', name: 'House', keywords: 'home house' },
  { emoji: '🏡', name: 'House with garden', keywords: 'home house' },
  { emoji: '🏢', name: 'Office building', keywords: 'office building' },
  { emoji: '🏣', name: 'Japanese post office', keywords: 'post office' },
  { emoji: '🏤', name: 'Post office', keywords: 'post office' },
  { emoji: '🏥', name: 'Hospital', keywords: 'hospital medical' },
  { emoji: '🏦', name: 'Bank', keywords: 'bank money' },
  { emoji: '🏨', name: 'Hotel', keywords: 'hotel travel' },
  { emoji: '🏩', name: 'Love hotel', keywords: 'hotel love' },
  { emoji: '🏪', name: 'Convenience store', keywords: 'store shop' },
  { emoji: '🏫', name: 'School', keywords: 'school building' },
  { emoji: '🏬', name: 'Department store', keywords: 'store shop' },
  { emoji: '🏭', name: 'Factory', keywords: 'factory building' },
  { emoji: '🏯', name: 'Japanese castle', keywords: 'castle travel' },
  { emoji: '🏰', name: 'Castle', keywords: 'castle travel' },
  { emoji: '💒', name: 'Wedding', keywords: 'wedding chapel' },
  { emoji: '🗼', name: 'Tokyo tower', keywords: 'tower travel' },
  { emoji: '🗽', name: 'Statue of Liberty', keywords: 'statue travel' },
  { emoji: '⛪', name: 'Church', keywords: 'church building' },
  { emoji: '🕌', name: 'Mosque', keywords: 'mosque building' },
  { emoji: '🛕', name: 'Hindu temple', keywords: 'temple building' },
  { emoji: '🕍', name: 'Synagogue', keywords: 'synagogue building' },
  { emoji: '⛩️', name: 'Shinto shrine', keywords: 'shrine travel' },
  { emoji: '🕋', name: 'Kaaba', keywords: 'kaaba building' },
  { emoji: '⛲', name: 'Fountain', keywords: 'fountain travel' },
  { emoji: '⛺', name: 'Tent', keywords: 'camping tent' },
  { emoji: '🌁', name: 'Foggy', keywords: 'fog city' },
  { emoji: '🌃', name: 'Night with stars', keywords: 'city night' },
  { emoji: '🏙️', name: 'Cityscape', keywords: 'city' },
  { emoji: '🌄', name: 'Sunrise mountains', keywords: 'sunrise' },
  { emoji: '🌅', name: 'Sunrise', keywords: 'sunrise' },
  { emoji: '🌆', name: 'City dusk', keywords: 'city sunset' },
  { emoji: '🌇', name: 'Sunset', keywords: 'sunset city' },
  { emoji: '🌉', name: 'Bridge night', keywords: 'bridge night' },
  { emoji: '♨️', name: 'Hot springs', keywords: 'hot spring' },
  { emoji: '🎠', name: 'Carousel horse', keywords: 'amusement park' },
  { emoji: '🛝', name: 'Playground slide', keywords: 'playground' },
  { emoji: '🎡', name: 'Ferris wheel', keywords: 'amusement park' },
  { emoji: '🎢', name: 'Roller coaster', keywords: 'amusement park' },
  { emoji: '💈', name: 'Barber pole', keywords: 'barber' },
  { emoji: '🎪', name: 'Circus tent', keywords: 'circus' },
  { emoji: '🚂', name: 'Locomotive', keywords: 'train travel' },
  { emoji: '🚃', name: 'Railway car', keywords: 'train travel' },
  { emoji: '🚄', name: 'High-speed train', keywords: 'train travel' },
  { emoji: '🚅', name: 'Bullet train', keywords: 'train travel' },
  { emoji: '🚆', name: 'Train', keywords: 'train travel' },
  { emoji: '🚇', name: 'Metro', keywords: 'subway train' },
  { emoji: '🚈', name: 'Light rail', keywords: 'train travel' },
  { emoji: '🚉', name: 'Station', keywords: 'train station' },
  { emoji: '🚊', name: 'Tram', keywords: 'tram train' },
  { emoji: '🚝', name: 'Monorail', keywords: 'train travel' },
  { emoji: '🚞', name: 'Mountain railway', keywords: 'train mountain' },
  { emoji: '🚋', name: 'Tram car', keywords: 'tram travel' },
  { emoji: '🚌', name: 'Bus', keywords: 'bus travel' },
  { emoji: '🚍', name: 'Oncoming bus', keywords: 'bus travel' },
  { emoji: '🚎', name: 'Trolleybus', keywords: 'bus travel' },
  { emoji: '🚐', name: 'Minibus', keywords: 'van travel' },
  { emoji: '🚑', name: 'Ambulance', keywords: 'ambulance emergency' },
  { emoji: '🚒', name: 'Fire engine', keywords: 'fire truck emergency' },
  { emoji: '🚓', name: 'Police car', keywords: 'police car' },
  { emoji: '🚔', name: 'Oncoming police car', keywords: 'police car' },
  { emoji: '🚕', name: 'Taxi', keywords: 'taxi car' },
  { emoji: '🚖', name: 'Oncoming taxi', keywords: 'taxi car' },
  { emoji: '🚗', name: 'Car', keywords: 'car auto vehicle garage' },
  { emoji: '🚘', name: 'Oncoming car', keywords: 'car auto vehicle garage' },
  { emoji: '🚙', name: 'Sport utility vehicle', keywords: 'suv car garage' },
  { emoji: '🛻', name: 'Pickup truck', keywords: 'truck car garage' },
  { emoji: '🚚', name: 'Delivery truck', keywords: 'truck delivery garage' },
  { emoji: '🚛', name: 'Articulated truck', keywords: 'truck semi garage' },
  { emoji: '🚜', name: 'Tractor', keywords: 'tractor vehicle' },
  { emoji: '🏎️', name: 'Racing car', keywords: 'race car garage' },
  { emoji: '🏍️', name: 'Motorcycle', keywords: 'motorcycle bike garage' },
  { emoji: '🛵', name: 'Motor scooter', keywords: 'scooter motorcycle' },
  { emoji: '🦽', name: 'Manual wheelchair', keywords: 'wheelchair' },
  { emoji: '🦼', name: 'Motorized wheelchair', keywords: 'wheelchair' },
  { emoji: '🛺', name: 'Auto rickshaw', keywords: 'rickshaw vehicle' },
  { emoji: '🚲', name: 'Bicycle', keywords: 'bike bicycle' },
  { emoji: '🛴', name: 'Kick scooter', keywords: 'scooter' },
  { emoji: '🛹', name: 'Skateboard', keywords: 'skateboard' },
  { emoji: '🛼', name: 'Roller skate', keywords: 'skate' },
  { emoji: '🚏', name: 'Bus stop', keywords: 'bus stop' },
  { emoji: '🛣️', name: 'Motorway', keywords: 'road highway' },
  { emoji: '🛤️', name: 'Railway track', keywords: 'train track' },
  { emoji: '🛢️', name: 'Oil drum', keywords: 'oil barrel' },
  { emoji: '⛽', name: 'Fuel pump', keywords: 'gas fuel car' },
  { emoji: '🚨', name: 'Police light', keywords: 'alarm emergency' },
  { emoji: '🚥', name: 'Horizontal traffic light', keywords: 'traffic light' },
  { emoji: '🚦', name: 'Vertical traffic light', keywords: 'traffic light' },
  { emoji: '🛑', name: 'Stop sign', keywords: 'stop sign' },
  { emoji: '🚧', name: 'Construction', keywords: 'construction road' },
  { emoji: '⚓', name: 'Anchor', keywords: 'boat anchor' },
  { emoji: '⛵', name: 'Sailboat', keywords: 'boat sail travel' },
  { emoji: '🛶', name: 'Canoe', keywords: 'boat canoe' },
  { emoji: '🚤', name: 'Speedboat', keywords: 'boat speed' },
  { emoji: '🛳️', name: 'Passenger ship', keywords: 'ship boat' },
  { emoji: '⛴️', name: 'Ferry', keywords: 'boat ferry' },
  { emoji: '🛥️', name: 'Motor boat', keywords: 'boat' },
  { emoji: '🚢', name: 'Ship', keywords: 'ship boat' },
  { emoji: '✈️', name: 'Airplane', keywords: 'plane travel' },
  { emoji: '🛩️', name: 'Small airplane', keywords: 'plane travel' },
  { emoji: '🛫', name: 'Airplane departure', keywords: 'plane travel' },
  { emoji: '🛬', name: 'Airplane arrival', keywords: 'plane travel' },
  { emoji: '🪂', name: 'Parachute', keywords: 'parachute' },
  { emoji: '💺', name: 'Seat', keywords: 'seat plane' },
  { emoji: '🚁', name: 'Helicopter', keywords: 'helicopter' },
  { emoji: '🚟', name: 'Suspension railway', keywords: 'train' },
  { emoji: '🚠', name: 'Mountain cableway', keywords: 'cable car' },
  { emoji: '🚡', name: 'Aerial tramway', keywords: 'tramway' },
  { emoji: '🛰️', name: 'Satellite', keywords: 'satellite space' },
  { emoji: '🚀', name: 'Rocket', keywords: 'rocket space launch' },
  { emoji: '🛸', name: 'Flying saucer', keywords: 'ufo space' },
  { emoji: '🛎️', name: 'Bellhop bell', keywords: 'hotel bell' },
  { emoji: '🧳', name: 'Luggage', keywords: 'travel bag' },
  { emoji: '⌛', name: 'Hourglass done', keywords: 'time hourglass' },
  { emoji: '⏳', name: 'Hourglass not done', keywords: 'time hourglass' },
  { emoji: '⌚', name: 'Watch', keywords: 'time watch' },
  { emoji: '⏰', name: 'Alarm clock', keywords: 'time alarm' },
  { emoji: '⏱️', name: 'Stopwatch', keywords: 'time stopwatch' },
  { emoji: '⏲️', name: 'Timer clock', keywords: 'time timer' },
  { emoji: '🕰️', name: 'Mantelpiece clock', keywords: 'time clock' },
  { emoji: '🕛', name: 'Twelve oclock', keywords: 'time clock' },
  { emoji: '🌑', name: 'New moon symbol', keywords: 'moon night' },
  { emoji: '🎃', name: 'Jack-o-lantern', keywords: 'halloween pumpkin' },
  { emoji: '🎄', name: 'Christmas tree holiday', keywords: 'christmas holiday' },
  { emoji: '🎆', name: 'Fireworks', keywords: 'fireworks celebrate' },
  { emoji: '🎇', name: 'Sparkler', keywords: 'sparkler celebrate' },
  { emoji: '🧨', name: 'Firecracker', keywords: 'fireworks celebrate' },
  { emoji: '✨', name: 'Sparkles shine', keywords: 'sparkle shine' },
  { emoji: '🎈', name: 'Balloon', keywords: 'party birthday' },
  { emoji: '🎉', name: 'Party popper', keywords: 'party celebrate' },
  { emoji: '🎊', name: 'Confetti ball', keywords: 'party celebrate' },
  { emoji: '🎋', name: 'Wish tree', keywords: 'wish decoration' },
  { emoji: '🎍', name: 'Pine decoration holiday', keywords: 'holiday' },
  { emoji: '🎎', name: 'Japanese dolls', keywords: 'dolls holiday' },
  { emoji: '🎏', name: 'Carp streamer', keywords: 'decoration' },
  { emoji: '🎐', name: 'Wind chime', keywords: 'decoration' },
  { emoji: '🎑', name: 'Moon viewing', keywords: 'moon holiday' },
  { emoji: '🧧', name: 'Red envelope', keywords: 'gift money' },
  { emoji: '🎀', name: 'Ribbon', keywords: 'gift bow' },
  { emoji: '🎁', name: 'Wrapped gift', keywords: 'gift present' },
  { emoji: '🎗️', name: 'Reminder ribbon', keywords: 'ribbon' },
  { emoji: '🎟️', name: 'Admission tickets', keywords: 'ticket' },
  { emoji: '🎫', name: 'Ticket', keywords: 'ticket event' },
  { emoji: '🎖️', name: 'Military medal', keywords: 'medal award' },
  { emoji: '🏆', name: 'Trophy', keywords: 'winner award' },
  { emoji: '🏅', name: 'Sports medal', keywords: 'medal award' },
  { emoji: '🥇', name: 'Gold medal', keywords: 'first winner' },
  { emoji: '🥈', name: 'Silver medal', keywords: 'second award' },
  { emoji: '🥉', name: 'Bronze medal', keywords: 'third award' },
  { emoji: '⚽', name: 'Soccer ball', keywords: 'soccer sport' },
  { emoji: '⚾', name: 'Baseball', keywords: 'baseball sport' },
  { emoji: '🥎', name: 'Softball', keywords: 'softball sport' },
  { emoji: '🏀', name: 'Basketball', keywords: 'basketball sport' },
  { emoji: '🏐', name: 'Volleyball', keywords: 'volleyball sport' },
  { emoji: '🏈', name: 'Football', keywords: 'football sport' },
  { emoji: '🏉', name: 'Rugby football', keywords: 'rugby sport' },
  { emoji: '🎾', name: 'Tennis', keywords: 'tennis sport' },
  { emoji: '🥏', name: 'Flying disc', keywords: 'frisbee sport' },
  { emoji: '🎳', name: 'Bowling', keywords: 'bowling sport' },
  { emoji: '🏏', name: 'Cricket game', keywords: 'cricket sport' },
  { emoji: '🏑', name: 'Field hockey', keywords: 'hockey sport' },
  { emoji: '🏒', name: 'Ice hockey', keywords: 'hockey sport' },
  { emoji: '🥍', name: 'Lacrosse', keywords: 'lacrosse sport' },
  { emoji: '🏓', name: 'Ping pong', keywords: 'table tennis sport' },
  { emoji: '🏸', name: 'Badminton', keywords: 'badminton sport' },
  { emoji: '🥊', name: 'Boxing glove', keywords: 'boxing sport' },
  { emoji: '🥋', name: 'Martial arts uniform', keywords: 'karate sport' },
  { emoji: '🥅', name: 'Goal net', keywords: 'goal sport' },
  { emoji: '⛳', name: 'Flag in hole', keywords: 'golf sport' },
  { emoji: '⛸️', name: 'Ice skate', keywords: 'skate sport' },
  { emoji: '🎣', name: 'Fishing pole', keywords: 'fishing sport' },
  { emoji: '🤿', name: 'Diving mask', keywords: 'diving swim' },
  { emoji: '🎽', name: 'Running shirt', keywords: 'running sport' },
  { emoji: '🎿', name: 'Skis', keywords: 'ski sport' },
  { emoji: '🛷', name: 'Sled', keywords: 'sled snow' },
  { emoji: '🥌', name: 'Curling stone', keywords: 'curling sport' },
  { emoji: '🎯', name: 'Bullseye', keywords: 'target goal' },
  { emoji: '🪀', name: 'Yo-yo', keywords: 'toy game' },
  { emoji: '🪁', name: 'Kite', keywords: 'kite toy' },
  { emoji: '🎱', name: 'Pool 8 ball', keywords: 'pool billiards game' },
  { emoji: '🔮', name: 'Crystal ball', keywords: 'magic future' },
  { emoji: '🪄', name: 'Magic wand', keywords: 'magic wand' },
  { emoji: '🧿', name: 'Nazar amulet', keywords: 'amulet' },
  { emoji: '🎮', name: 'Video game', keywords: 'game controller' },
  { emoji: '🕹️', name: 'Joystick', keywords: 'game' },
  { emoji: '🎰', name: 'Slot machine', keywords: 'game casino' },
  { emoji: '🎲', name: 'Game die', keywords: 'dice game' },
  { emoji: '🧩', name: 'Puzzle piece', keywords: 'puzzle game' },
  { emoji: '🧸', name: 'Teddy bear', keywords: 'toy bear' },
  { emoji: '🪅', name: 'Pinata', keywords: 'party' },
  { emoji: '🪩', name: 'Mirror ball', keywords: 'dance party' },
  { emoji: '♠️', name: 'Spade suit', keywords: 'cards game' },
  { emoji: '♥️', name: 'Heart suit', keywords: 'cards game' },
  { emoji: '♦️', name: 'Diamond suit', keywords: 'cards game' },
  { emoji: '♣️', name: 'Club suit', keywords: 'cards game' },
  { emoji: '♟️', name: 'Chess pawn', keywords: 'chess game' },
  { emoji: '🃏', name: 'Joker', keywords: 'cards game' },
  { emoji: '🀄', name: 'Mahjong red dragon', keywords: 'mahjong game' },
  { emoji: '🎴', name: 'Flower playing cards', keywords: 'cards game' },
  { emoji: '🎭', name: 'Performing arts', keywords: 'theater art' },
  { emoji: '🖼️', name: 'Framed picture', keywords: 'art picture' },
  { emoji: '🎨', name: 'Artist palette', keywords: 'art paint' },
  { emoji: '🧵', name: 'Thread', keywords: 'thread sewing' },
  { emoji: '🪡', name: 'Sewing needle', keywords: 'sewing' },
  { emoji: '🧶', name: 'Yarn', keywords: 'yarn knit' },
  { emoji: '🪢', name: 'Knot', keywords: 'knot rope' },
  { emoji: '👓', name: 'Glasses', keywords: 'glasses' },
  { emoji: '🕶️', name: 'Sunglasses', keywords: 'sunglasses shades' },
  { emoji: '🥽', name: 'Goggles', keywords: 'goggles' },
  { emoji: '🥼', name: 'Lab coat', keywords: 'coat lab' },
  { emoji: '🦺', name: 'Safety vest', keywords: 'safety vest' },
  { emoji: '👔', name: 'Necktie', keywords: 'tie clothes' },
  { emoji: '👕', name: 'T-shirt', keywords: 'shirt clothes' },
  { emoji: '👖', name: 'Jeans', keywords: 'pants clothes' },
  { emoji: '🧣', name: 'Scarf', keywords: 'scarf clothes' },
  { emoji: '🧤', name: 'Gloves', keywords: 'gloves clothes' },
  { emoji: '🧥', name: 'Coat', keywords: 'coat clothes' },
  { emoji: '🧦', name: 'Socks', keywords: 'socks clothes' },
  { emoji: '👗', name: 'Dress', keywords: 'dress clothes' },
  { emoji: '👘', name: 'Kimono', keywords: 'kimono clothes' },
  { emoji: '🥻', name: 'Sari', keywords: 'sari clothes' },
  { emoji: '🩱', name: 'One-piece swimsuit', keywords: 'swimsuit clothes' },
  { emoji: '🩲', name: 'Briefs', keywords: 'underwear clothes' },
  { emoji: '🩳', name: 'Shorts', keywords: 'shorts clothes' },
  { emoji: '👙', name: 'Bikini', keywords: 'bikini clothes' },
  { emoji: '👚', name: 'Woman clothes', keywords: 'clothes shirt' },
  { emoji: '👛', name: 'Purse', keywords: 'bag purse' },
  { emoji: '👜', name: 'Handbag', keywords: 'bag handbag' },
  { emoji: '👝', name: 'Clutch bag', keywords: 'bag clutch' },
  { emoji: '🛍️', name: 'Shopping bags', keywords: 'shopping bags' },
  { emoji: '🎒', name: 'Backpack', keywords: 'bag backpack' },
  { emoji: '🩴', name: 'Thong sandal', keywords: 'sandal shoe' },
  { emoji: '👞', name: 'Mans shoe', keywords: 'shoe' },
  { emoji: '👟', name: 'Running shoe', keywords: 'shoe sneaker' },
  { emoji: '🥾', name: 'Hiking boot', keywords: 'boot shoe' },
  { emoji: '🥿', name: 'Flat shoe', keywords: 'shoe' },
  { emoji: '👠', name: 'High-heeled shoe', keywords: 'shoe heel' },
  { emoji: '👡', name: 'Woman sandal', keywords: 'shoe sandal' },
  { emoji: '🩰', name: 'Ballet shoes', keywords: 'ballet shoe' },
  { emoji: '👢', name: 'Woman boot', keywords: 'boot shoe' },
  { emoji: '👑', name: 'Crown', keywords: 'crown founder royal' },
  { emoji: '👒', name: 'Woman hat', keywords: 'hat' },
  { emoji: '🎩', name: 'Top hat', keywords: 'hat fancy' },
  { emoji: '🎓', name: 'Graduation cap', keywords: 'graduate school' },
  { emoji: '🧢', name: 'Billed cap', keywords: 'hat cap' },
  { emoji: '🪖', name: 'Military helmet', keywords: 'helmet' },
  { emoji: '⛑️', name: 'Rescue helmet', keywords: 'helmet safety' },
  { emoji: '📿', name: 'Prayer beads', keywords: 'beads prayer' },
  { emoji: '💄', name: 'Lipstick', keywords: 'makeup lipstick' },
  { emoji: '💍', name: 'Ring', keywords: 'ring wedding' },
  { emoji: '💎', name: 'Gem stone', keywords: 'diamond gem' },
  { emoji: '🔇', name: 'Muted speaker', keywords: 'mute sound' },
  { emoji: '🔈', name: 'Speaker low', keywords: 'sound' },
  { emoji: '🔉', name: 'Speaker medium', keywords: 'sound' },
  { emoji: '🔊', name: 'Speaker high', keywords: 'sound loud' },
  { emoji: '📢', name: 'Loudspeaker', keywords: 'announcement' },
  { emoji: '📣', name: 'Megaphone', keywords: 'announcement' },
  { emoji: '📯', name: 'Postal horn', keywords: 'horn' },
  { emoji: '🔔', name: 'Bell', keywords: 'notification bell' },
  { emoji: '🔕', name: 'Bell slash', keywords: 'mute notification' },
  { emoji: '🎼', name: 'Musical score', keywords: 'music' },
  { emoji: '🎵', name: 'Musical note', keywords: 'music note' },
  { emoji: '🎶', name: 'Musical notes', keywords: 'music notes' },
  { emoji: '🎙️', name: 'Studio microphone', keywords: 'mic podcast' },
  { emoji: '🎚️', name: 'Level slider', keywords: 'music audio' },
  { emoji: '🎛️', name: 'Control knobs', keywords: 'music audio' },
  { emoji: '🎤', name: 'Microphone', keywords: 'mic music' },
  { emoji: '🎧', name: 'Headphone', keywords: 'music headphones' },
  { emoji: '📻', name: 'Radio', keywords: 'radio music' },
  { emoji: '🎷', name: 'Saxophone', keywords: 'music instrument' },
  { emoji: '🪗', name: 'Accordion', keywords: 'music instrument' },
  { emoji: '🎸', name: 'Guitar', keywords: 'music instrument' },
  { emoji: '🎹', name: 'Musical keyboard', keywords: 'music piano' },
  { emoji: '🎺', name: 'Trumpet', keywords: 'music instrument' },
  { emoji: '🎻', name: 'Violin', keywords: 'music instrument' },
  { emoji: '🪕', name: 'Banjo', keywords: 'music instrument' },
  { emoji: '🥁', name: 'Drum', keywords: 'music instrument' },
  { emoji: '🪘', name: 'Long drum', keywords: 'music instrument' },
  { emoji: '📱', name: 'Mobile phone', keywords: 'phone mobile' },
  { emoji: '📲', name: 'Mobile phone arrow', keywords: 'phone mobile' },
  { emoji: '☎️', name: 'Telephone', keywords: 'phone call' },
  { emoji: '📞', name: 'Telephone receiver', keywords: 'phone call' },
  { emoji: '📟', name: 'Pager', keywords: 'pager' },
  { emoji: '📠', name: 'Fax machine', keywords: 'fax' },
  { emoji: '🔋', name: 'Battery', keywords: 'battery power' },
  { emoji: '🪫', name: 'Low battery', keywords: 'battery low' },
  { emoji: '🔌', name: 'Electric plug', keywords: 'plug power' },
  { emoji: '💻', name: 'Laptop', keywords: 'computer laptop' },
  { emoji: '🖥️', name: 'Desktop computer', keywords: 'computer desktop' },
  { emoji: '🖨️', name: 'Printer', keywords: 'printer' },
  { emoji: '⌨️', name: 'Keyboard', keywords: 'keyboard computer' },
  { emoji: '🖱️', name: 'Computer mouse', keywords: 'mouse computer' },
  { emoji: '🖲️', name: 'Trackball', keywords: 'trackball computer' },
  { emoji: '💽', name: 'Computer disk', keywords: 'disk computer' },
  { emoji: '💾', name: 'Floppy disk', keywords: 'save disk' },
  { emoji: '💿', name: 'Optical disk', keywords: 'cd disk' },
  { emoji: '📀', name: 'DVD', keywords: 'dvd disk' },
  { emoji: '🧮', name: 'Abacus', keywords: 'calculator math' },
  { emoji: '🎥', name: 'Movie camera', keywords: 'movie video camera' },
  { emoji: '🎞️', name: 'Film frames', keywords: 'film movie' },
  { emoji: '📽️', name: 'Film projector', keywords: 'film movie' },
  { emoji: '🎬', name: 'Clapper board', keywords: 'movie video' },
  { emoji: '📺', name: 'Television', keywords: 'tv video' },
  { emoji: '📷', name: 'Camera', keywords: 'camera photo' },
  { emoji: '📸', name: 'Camera flash', keywords: 'camera photo' },
  { emoji: '📹', name: 'Video camera', keywords: 'video camera' },
  { emoji: '📼', name: 'Videocassette', keywords: 'video tape' },
  { emoji: '🔍', name: 'Magnifying glass left', keywords: 'search find' },
  { emoji: '🔎', name: 'Magnifying glass right', keywords: 'search find' },
  { emoji: '🕯️', name: 'Candle', keywords: 'candle' },
  { emoji: '💡', name: 'Light bulb', keywords: 'idea light' },
  { emoji: '🔦', name: 'Flashlight', keywords: 'flashlight light' },
  { emoji: '🏮', name: 'Red paper lantern', keywords: 'lantern light' },
  { emoji: '🪔', name: 'Diya lamp', keywords: 'lamp light' },
  { emoji: '📔', name: 'Notebook decorative cover', keywords: 'book notebook' },
  { emoji: '📕', name: 'Closed book', keywords: 'book' },
  { emoji: '📖', name: 'Open book', keywords: 'book read' },
  { emoji: '📗', name: 'Green book', keywords: 'book' },
  { emoji: '📘', name: 'Blue book', keywords: 'book' },
  { emoji: '📙', name: 'Orange book', keywords: 'book' },
  { emoji: '📚', name: 'Books', keywords: 'books read' },
  { emoji: '📓', name: 'Notebook', keywords: 'notebook' },
  { emoji: '📒', name: 'Ledger', keywords: 'ledger notebook' },
  { emoji: '📃', name: 'Page curl', keywords: 'page document' },
  { emoji: '📜', name: 'Scroll', keywords: 'scroll document' },
  { emoji: '📄', name: 'Page facing up', keywords: 'page document' },
  { emoji: '📰', name: 'Newspaper', keywords: 'newspaper news' },
  { emoji: '🗞️', name: 'Rolled newspaper', keywords: 'newspaper news' },
  { emoji: '📑', name: 'Bookmark tabs', keywords: 'bookmark tabs' },
  { emoji: '🔖', name: 'Bookmark', keywords: 'bookmark' },
  { emoji: '🏷️', name: 'Label', keywords: 'label tag' },
  { emoji: '💰', name: 'Money bag', keywords: 'money cash' },
  { emoji: '🪙', name: 'Coin', keywords: 'money coin' },
  { emoji: '💴', name: 'Yen banknote', keywords: 'money yen' },
  { emoji: '💵', name: 'Dollar banknote', keywords: 'money dollar cash' },
  { emoji: '💶', name: 'Euro banknote', keywords: 'money euro' },
  { emoji: '💷', name: 'Pound banknote', keywords: 'money pound' },
  { emoji: '💸', name: 'Money with wings', keywords: 'money cash' },
  { emoji: '💳', name: 'Credit card', keywords: 'card payment money' },
  { emoji: '🧾', name: 'Receipt', keywords: 'receipt payment' },
  { emoji: '💹', name: 'Chart yen up', keywords: 'chart money' },
  { emoji: '✉️', name: 'Envelope', keywords: 'mail email' },
  { emoji: '📧', name: 'Email', keywords: 'mail email' },
  { emoji: '📨', name: 'Incoming envelope', keywords: 'mail email' },
  { emoji: '📩', name: 'Envelope arrow', keywords: 'mail email' },
  { emoji: '📤', name: 'Outbox tray', keywords: 'mail send' },
  { emoji: '📥', name: 'Inbox tray', keywords: 'mail inbox' },
  { emoji: '📦', name: 'Package', keywords: 'package box' },
  { emoji: '📫', name: 'Mailbox raised flag', keywords: 'mailbox mail' },
  { emoji: '📪', name: 'Mailbox lowered flag', keywords: 'mailbox mail' },
  { emoji: '📬', name: 'Open mailbox raised flag', keywords: 'mailbox mail' },
  { emoji: '📭', name: 'Open mailbox lowered flag', keywords: 'mailbox mail' },
  { emoji: '📮', name: 'Postbox', keywords: 'mail postbox' },
  { emoji: '🗳️', name: 'Ballot box', keywords: 'vote ballot' },
  { emoji: '✏️', name: 'Pencil', keywords: 'pencil write' },
  { emoji: '✒️', name: 'Black nib', keywords: 'pen write' },
  { emoji: '🖋️', name: 'Fountain pen', keywords: 'pen write' },
  { emoji: '🖊️', name: 'Pen', keywords: 'pen write' },
  { emoji: '🖌️', name: 'Paintbrush', keywords: 'paint art' },
  { emoji: '🖍️', name: 'Crayon', keywords: 'crayon art' },
  { emoji: '📝', name: 'Memo', keywords: 'memo note write' },
  { emoji: '💼', name: 'Briefcase', keywords: 'work business' },
  { emoji: '📁', name: 'File folder', keywords: 'folder file' },
  { emoji: '📂', name: 'Open file folder', keywords: 'folder file' },
  { emoji: '🗂️', name: 'Card index dividers', keywords: 'file organize' },
  { emoji: '📅', name: 'Calendar', keywords: 'calendar date' },
  { emoji: '📆', name: 'Tear-off calendar', keywords: 'calendar date' },
  { emoji: '🗒️', name: 'Spiral notepad', keywords: 'notepad note' },
  { emoji: '🗓️', name: 'Spiral calendar', keywords: 'calendar date' },
  { emoji: '📇', name: 'Card index', keywords: 'card index' },
  { emoji: '📈', name: 'Chart increasing', keywords: 'chart up' },
  { emoji: '📉', name: 'Chart decreasing', keywords: 'chart down' },
  { emoji: '📊', name: 'Bar chart', keywords: 'chart graph' },
  { emoji: '📋', name: 'Clipboard', keywords: 'clipboard' },
  { emoji: '📌', name: 'Pushpin', keywords: 'pin' },
  { emoji: '📍', name: 'Round pushpin', keywords: 'pin location' },
  { emoji: '📎', name: 'Paperclip', keywords: 'clip attach' },
  { emoji: '🖇️', name: 'Linked paperclips', keywords: 'clip attach' },
  { emoji: '📏', name: 'Straight ruler', keywords: 'ruler' },
  { emoji: '📐', name: 'Triangular ruler', keywords: 'ruler' },
  { emoji: '✂️', name: 'Scissors', keywords: 'cut scissors' },
  { emoji: '🗃️', name: 'Card file box', keywords: 'file box' },
  { emoji: '🗄️', name: 'File cabinet', keywords: 'file cabinet' },
  { emoji: '🗑️', name: 'Wastebasket', keywords: 'trash delete' },
  { emoji: '🔒', name: 'Locked', keywords: 'lock secure' },
  { emoji: '🔓', name: 'Unlocked', keywords: 'unlock' },
  { emoji: '🔏', name: 'Locked pen', keywords: 'lock secure' },
  { emoji: '🔐', name: 'Locked key', keywords: 'lock secure' },
  { emoji: '🔑', name: 'Key', keywords: 'key lock' },
  { emoji: '🗝️', name: 'Old key', keywords: 'key lock' },
  { emoji: '🔨', name: 'Hammer', keywords: 'hammer tool' },
  { emoji: '🪓', name: 'Axe', keywords: 'axe tool' },
  { emoji: '⛏️', name: 'Pick', keywords: 'pick tool' },
  { emoji: '⚒️', name: 'Hammer and pick', keywords: 'tools' },
  { emoji: '🛠️', name: 'Hammer and wrench', keywords: 'tools mechanic' },
  { emoji: '🗡️', name: 'Dagger', keywords: 'dagger' },
  { emoji: '⚔️', name: 'Crossed swords', keywords: 'swords' },
  { emoji: '🔫', name: 'Water pistol', keywords: 'toy pistol' },
  { emoji: '🪃', name: 'Boomerang', keywords: 'boomerang' },
  { emoji: '🏹', name: 'Bow and arrow', keywords: 'arrow bow' },
  { emoji: '🛡️', name: 'Shield', keywords: 'shield verified' },
  { emoji: '🪚', name: 'Carpentry saw', keywords: 'saw tool' },
  { emoji: '🔧', name: 'Wrench', keywords: 'wrench tool mechanic' },
  { emoji: '🪛', name: 'Screwdriver', keywords: 'screwdriver tool' },
  { emoji: '🔩', name: 'Nut and bolt', keywords: 'bolt tool' },
  { emoji: '⚙️', name: 'Gear', keywords: 'gear settings' },
  { emoji: '🗜️', name: 'Clamp', keywords: 'clamp tool' },
  { emoji: '⚖️', name: 'Balance scale', keywords: 'scale law' },
  { emoji: '🦯', name: 'White cane', keywords: 'cane accessibility' },
  { emoji: '🔗', name: 'Link', keywords: 'link chain' },
  { emoji: '⛓️', name: 'Chains', keywords: 'chain link' },
  { emoji: '🪝', name: 'Hook', keywords: 'hook' },
  { emoji: '🧰', name: 'Toolbox', keywords: 'tools toolbox' },
  { emoji: '🧲', name: 'Magnet', keywords: 'magnet' },
  { emoji: '🪜', name: 'Ladder', keywords: 'ladder' },
  { emoji: '⚗️', name: 'Alembic', keywords: 'science' },
  { emoji: '🧪', name: 'Test tube', keywords: 'science test' },
  { emoji: '🧫', name: 'Petri dish', keywords: 'science' },
  { emoji: '🧬', name: 'DNA', keywords: 'science dna' },
  { emoji: '🔬', name: 'Microscope', keywords: 'science microscope' },
  { emoji: '🔭', name: 'Telescope', keywords: 'space telescope' },
  { emoji: '📡', name: 'Satellite antenna', keywords: 'satellite' },
  { emoji: '💉', name: 'Syringe', keywords: 'medical shot' },
  { emoji: '🩸', name: 'Drop of blood', keywords: 'blood medical' },
  { emoji: '💊', name: 'Pill', keywords: 'medicine pill' },
  { emoji: '🩹', name: 'Bandage', keywords: 'bandage medical' },
  { emoji: '🩺', name: 'Stethoscope', keywords: 'doctor medical' },
  { emoji: '🚪', name: 'Door', keywords: 'door' },
  { emoji: '🛗', name: 'Elevator', keywords: 'elevator' },
  { emoji: '🪞', name: 'Mirror', keywords: 'mirror' },
  { emoji: '🪟', name: 'Window', keywords: 'window' },
  { emoji: '🛏️', name: 'Bed furniture', keywords: 'bed sleep' },
  { emoji: '🛋️', name: 'Couch lamp', keywords: 'couch sofa' },
  { emoji: '🪑', name: 'Chair', keywords: 'chair' },
  { emoji: '🚽', name: 'Toilet', keywords: 'toilet' },
  { emoji: '🪠', name: 'Plunger', keywords: 'plunger' },
  { emoji: '🚿', name: 'Shower', keywords: 'shower' },
  { emoji: '🛁', name: 'Bathtub', keywords: 'bath tub' },
  { emoji: '🪤', name: 'Mouse trap', keywords: 'trap' },
  { emoji: '🪒', name: 'Razor', keywords: 'razor' },
  { emoji: '🧴', name: 'Lotion bottle', keywords: 'lotion bottle' },
  { emoji: '🧷', name: 'Safety pin', keywords: 'pin' },
  { emoji: '🧹', name: 'Broom', keywords: 'broom clean' },
  { emoji: '🧺', name: 'Basket', keywords: 'basket' },
  { emoji: '🧻', name: 'Roll of paper', keywords: 'paper toilet' },
  { emoji: '🪣', name: 'Bucket', keywords: 'bucket' },
  { emoji: '🧼', name: 'Soap', keywords: 'soap clean' },
  { emoji: '🫧', name: 'Bubbles', keywords: 'bubbles clean' },
  { emoji: '🪥', name: 'Toothbrush', keywords: 'toothbrush dental' },
  { emoji: '🧽', name: 'Sponge', keywords: 'sponge clean' },
  { emoji: '🧯', name: 'Fire extinguisher', keywords: 'fire extinguisher' },
  { emoji: '🛒', name: 'Shopping cart', keywords: 'cart shopping' },
  { emoji: '🚬', name: 'Cigarette', keywords: 'cigarette smoke' },
  { emoji: '⚰️', name: 'Coffin', keywords: 'coffin' },
  { emoji: '🪦', name: 'Headstone', keywords: 'grave' },
  { emoji: '⚱️', name: 'Funeral urn', keywords: 'urn' },
  { emoji: '🗿', name: 'Moai', keywords: 'moai statue' },
  { emoji: '🪧', name: 'Placard', keywords: 'sign' },
  { emoji: '🏧', name: 'ATM sign', keywords: 'atm money' },
  { emoji: '🚮', name: 'Litter bin', keywords: 'trash' },
  { emoji: '🚰', name: 'Potable water', keywords: 'water' },
  { emoji: '♿', name: 'Wheelchair symbol', keywords: 'accessibility' },
  { emoji: '🚹', name: 'Mens room', keywords: 'restroom men' },
  { emoji: '🚺', name: 'Womens room', keywords: 'restroom women' },
  { emoji: '🚻', name: 'Restroom', keywords: 'restroom' },
  { emoji: '🚼', name: 'Baby symbol', keywords: 'baby' },
  { emoji: '🚾', name: 'Water closet', keywords: 'toilet restroom' },
  { emoji: '🛂', name: 'Passport control', keywords: 'passport travel' },
  { emoji: '🛃', name: 'Customs', keywords: 'customs travel' },
  { emoji: '🛄', name: 'Baggage claim', keywords: 'baggage travel' },
  { emoji: '🛅', name: 'Left luggage', keywords: 'luggage travel' },
  { emoji: '⚠️', name: 'Warning', keywords: 'warning danger' },
  { emoji: '🚸', name: 'Children crossing', keywords: 'children warning' },
  { emoji: '⛔', name: 'No entry', keywords: 'stop no' },
  { emoji: '🚫', name: 'Prohibited', keywords: 'no stop' },
  { emoji: '🚳', name: 'No bicycles', keywords: 'no bike' },
  { emoji: '🚭', name: 'No smoking', keywords: 'no smoke' },
  { emoji: '🚯', name: 'No littering', keywords: 'no trash' },
  { emoji: '🚱', name: 'Non-potable water', keywords: 'no water' },
  { emoji: '🚷', name: 'No pedestrians', keywords: 'no walking' },
  { emoji: '📵', name: 'No mobile phones', keywords: 'no phone' },
  { emoji: '🔞', name: 'No one under eighteen', keywords: 'age adult' },
  { emoji: '☢️', name: 'Radioactive', keywords: 'danger' },
  { emoji: '☣️', name: 'Biohazard', keywords: 'danger' },
  { emoji: '⬆️', name: 'Up arrow', keywords: 'arrow up' },
  { emoji: '↗️', name: 'Up-right arrow', keywords: 'arrow' },
  { emoji: '➡️', name: 'Right arrow', keywords: 'arrow right' },
  { emoji: '↘️', name: 'Down-right arrow', keywords: 'arrow' },
  { emoji: '⬇️', name: 'Down arrow', keywords: 'arrow down' },
  { emoji: '↙️', name: 'Down-left arrow', keywords: 'arrow' },
  { emoji: '⬅️', name: 'Left arrow', keywords: 'arrow left' },
  { emoji: '↖️', name: 'Up-left arrow', keywords: 'arrow' },
  { emoji: '↕️', name: 'Up-down arrow', keywords: 'arrow' },
  { emoji: '↔️', name: 'Left-right arrow', keywords: 'arrow' },
  { emoji: '↩️', name: 'Right arrow curving left', keywords: 'return arrow' },
  { emoji: '↪️', name: 'Left arrow curving right', keywords: 'arrow' },
  { emoji: '⤴️', name: 'Right arrow curving up', keywords: 'arrow' },
  { emoji: '⤵️', name: 'Right arrow curving down', keywords: 'arrow' },
  { emoji: '🔃', name: 'Clockwise vertical arrows', keywords: 'refresh arrows' },
  { emoji: '🔄', name: 'Counterclockwise arrows', keywords: 'refresh arrows' },
  { emoji: '🔙', name: 'Back arrow', keywords: 'back arrow' },
  { emoji: '🔚', name: 'End arrow', keywords: 'end arrow' },
  { emoji: '🔛', name: 'On arrow', keywords: 'on arrow' },
  { emoji: '🔜', name: 'Soon arrow', keywords: 'soon arrow' },
  { emoji: '🔝', name: 'Top arrow', keywords: 'top arrow' },
  { emoji: '🛐', name: 'Place of worship', keywords: 'worship' },
  { emoji: '⚛️', name: 'Atom symbol', keywords: 'science atom' },
  { emoji: '🕉️', name: 'Om', keywords: 'om religion' },
  { emoji: '✡️', name: 'Star of David', keywords: 'religion' },
  { emoji: '☸️', name: 'Wheel of dharma', keywords: 'religion' },
  { emoji: '☯️', name: 'Yin yang', keywords: 'yin yang' },
  { emoji: '✝️', name: 'Latin cross', keywords: 'cross religion' },
  { emoji: '☦️', name: 'Orthodox cross', keywords: 'cross religion' },
  { emoji: '☪️', name: 'Star and crescent', keywords: 'religion' },
  { emoji: '☮️', name: 'Peace symbol', keywords: 'peace' },
  { emoji: '🕎', name: 'Menorah', keywords: 'menorah religion' },
  { emoji: '🔯', name: 'Dotted six-pointed star', keywords: 'star' },
  { emoji: '♈', name: 'Aries', keywords: 'zodiac aries' },
  { emoji: '♉', name: 'Taurus', keywords: 'zodiac taurus' },
  { emoji: '♊', name: 'Gemini', keywords: 'zodiac gemini' },
  { emoji: '♋', name: 'Cancer', keywords: 'zodiac cancer' },
  { emoji: '♌', name: 'Leo', keywords: 'zodiac leo' },
  { emoji: '♍', name: 'Virgo', keywords: 'zodiac virgo' },
  { emoji: '♎', name: 'Libra', keywords: 'zodiac libra' },
  { emoji: '♏', name: 'Scorpio', keywords: 'zodiac scorpio' },
  { emoji: '♐', name: 'Sagittarius', keywords: 'zodiac sagittarius' },
  { emoji: '♑', name: 'Capricorn', keywords: 'zodiac capricorn' },
  { emoji: '♒', name: 'Aquarius', keywords: 'zodiac aquarius' },
  { emoji: '♓', name: 'Pisces', keywords: 'zodiac pisces' },
  { emoji: '⛎', name: 'Ophiuchus', keywords: 'zodiac' },
  { emoji: '🔀', name: 'Shuffle tracks', keywords: 'shuffle music' },
  { emoji: '🔁', name: 'Repeat button', keywords: 'repeat music' },
  { emoji: '🔂', name: 'Repeat single', keywords: 'repeat music' },
  { emoji: '▶️', name: 'Play button', keywords: 'play video' },
  { emoji: '⏩', name: 'Fast-forward', keywords: 'fast forward' },
  { emoji: '⏭️', name: 'Next track', keywords: 'next' },
  { emoji: '⏯️', name: 'Play pause', keywords: 'play pause' },
  { emoji: '◀️', name: 'Reverse button', keywords: 'reverse back' },
  { emoji: '⏪', name: 'Fast reverse', keywords: 'reverse' },
  { emoji: '⏮️', name: 'Last track', keywords: 'previous' },
  { emoji: '🔼', name: 'Upwards button', keywords: 'up' },
  { emoji: '⏫', name: 'Fast up button', keywords: 'up' },
  { emoji: '🔽', name: 'Downwards button', keywords: 'down' },
  { emoji: '⏬', name: 'Fast down button', keywords: 'down' },
  { emoji: '⏸️', name: 'Pause button', keywords: 'pause' },
  { emoji: '⏹️', name: 'Stop button', keywords: 'stop' },
  { emoji: '⏺️', name: 'Record button', keywords: 'record' },
  { emoji: '⏏️', name: 'Eject button', keywords: 'eject' },
  { emoji: '🎦', name: 'Cinema', keywords: 'movie cinema' },
  { emoji: '🔅', name: 'Dim button', keywords: 'brightness dim' },
  { emoji: '🔆', name: 'Bright button', keywords: 'brightness' },
  { emoji: '📶', name: 'Antenna bars', keywords: 'signal wifi' },
  { emoji: '📳', name: 'Vibration mode', keywords: 'phone vibrate' },
  { emoji: '📴', name: 'Mobile phone off', keywords: 'phone off' },
  { emoji: '♀️', name: 'Female sign', keywords: 'female' },
  { emoji: '♂️', name: 'Male sign', keywords: 'male' },
  { emoji: '⚧️', name: 'Transgender symbol', keywords: 'transgender' },
  { emoji: '✖️', name: 'Multiply', keywords: 'x no close' },
  { emoji: '➕', name: 'Plus', keywords: 'plus add' },
  { emoji: '➖', name: 'Minus', keywords: 'minus' },
  { emoji: '➗', name: 'Divide', keywords: 'divide' },
  { emoji: '🟰', name: 'Equals', keywords: 'equals' },
  { emoji: '♾️', name: 'Infinity', keywords: 'infinity' },
  { emoji: '‼️', name: 'Double exclamation', keywords: 'exclamation' },
  { emoji: '⁉️', name: 'Exclamation question', keywords: 'question exclamation' },
  { emoji: '❓', name: 'Red question mark', keywords: 'question' },
  { emoji: '❔', name: 'White question mark', keywords: 'question' },
  { emoji: '❕', name: 'White exclamation mark', keywords: 'exclamation' },
  { emoji: '❗', name: 'Red exclamation mark', keywords: 'exclamation' },
  { emoji: '〰️', name: 'Wavy dash', keywords: 'dash' },
  { emoji: '💱', name: 'Currency exchange', keywords: 'money exchange' },
  { emoji: '💲', name: 'Heavy dollar sign', keywords: 'money dollar' },
  { emoji: '⚕️', name: 'Medical symbol', keywords: 'medical' },
  { emoji: '♻️', name: 'Recycling symbol', keywords: 'recycle' },
  { emoji: '⚜️', name: 'Fleur-de-lis', keywords: 'symbol' },
  { emoji: '🔱', name: 'Trident emblem', keywords: 'trident' },
  { emoji: '📛', name: 'Name badge', keywords: 'badge name' },
  { emoji: '🔰', name: 'Japanese beginner', keywords: 'beginner' },
  { emoji: '⭕', name: 'Hollow red circle', keywords: 'circle yes' },
  { emoji: '✅', name: 'Check mark button', keywords: 'check yes done verified' },
  { emoji: '☑️', name: 'Check box', keywords: 'check yes' },
  { emoji: '✔️', name: 'Check mark', keywords: 'check yes' },
  { emoji: '❌', name: 'Cross mark', keywords: 'x no error' },
  { emoji: '❎', name: 'Cross mark button', keywords: 'x no' },
  { emoji: '➰', name: 'Curly loop', keywords: 'loop' },
  { emoji: '➿', name: 'Double curly loop', keywords: 'loop' },
  { emoji: '〽️', name: 'Part alternation mark', keywords: 'mark' },
  { emoji: '✳️', name: 'Eight-spoked asterisk', keywords: 'asterisk' },
  { emoji: '✴️', name: 'Eight-pointed star', keywords: 'star' },
  { emoji: '❇️', name: 'Sparkle', keywords: 'sparkle' },
  { emoji: '©️', name: 'Copyright', keywords: 'copyright' },
  { emoji: '®️', name: 'Registered', keywords: 'registered' },
  { emoji: '™️', name: 'Trade mark', keywords: 'trademark' },
  { emoji: '#️⃣', name: 'Keycap number sign', keywords: 'hash pound' },
  { emoji: '*️⃣', name: 'Keycap asterisk', keywords: 'asterisk' },
  { emoji: '0️⃣', name: 'Keycap zero', keywords: 'zero number' },
  { emoji: '1️⃣', name: 'Keycap one', keywords: 'one number' },
  { emoji: '2️⃣', name: 'Keycap two', keywords: 'two number' },
  { emoji: '3️⃣', name: 'Keycap three', keywords: 'three number' },
  { emoji: '4️⃣', name: 'Keycap four', keywords: 'four number' },
  { emoji: '5️⃣', name: 'Keycap five', keywords: 'five number' },
  { emoji: '6️⃣', name: 'Keycap six', keywords: 'six number' },
  { emoji: '7️⃣', name: 'Keycap seven', keywords: 'seven number' },
  { emoji: '8️⃣', name: 'Keycap eight', keywords: 'eight number' },
  { emoji: '9️⃣', name: 'Keycap nine', keywords: 'nine number' },
  { emoji: '🔟', name: 'Keycap ten', keywords: 'ten number' },
];
